import React from "react";
import {reduxForm} from "redux-form/immutable";
import Button from "../../components/Button";
import FormError from "../../components/forms/FormError";


const ReplacePackagesForShippingOrderForm = (props) => {
  let {errors, handleSubmit, submitting, showCancel} = props;
  // const createAndSendLabel = submitting ? "Standby..." : "Create replacement and send";
  const createAndReviewLabel = submitting ? "Standby..." : "Create replacement and review";

  return (
    <form onSubmit={handleSubmit}>
      <div className="fields">
        <p>{props.message}</p>
      </div>
      <FormError error={errors._error} />
      <div className="buttons column">
        {/* <Button label={createAndSendLabel} onClick={props.onSubmitCreateAndSend} active={!props.processing} /> */}
        <Button label={createAndReviewLabel} onClick={props.onSubmitCreateAndReview} active={!props.processing} />
        <Button show={showCancel} label="Cancel" primary={false} onClick={props.onCancel} active={!props.processing} />
      </div>
    </form>
  )
}

const ReduxForm = reduxForm({
  form: "ReplacePackagesForShippingOrderForm"
})(ReplacePackagesForShippingOrderForm);

export default ReduxForm;